module.exports = __webpack_public_path__ + "static/media/pizza1.afcc8058.png";